var React = require('react');

function WY (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M80.16 35.12l-0.4-28.88-36.64-0.32-35.2-1.84-3.92 57.84 37.36 1.84 39.12 0.32z"}));
}

WY.defaultProps = {"version":"1.1","width":"84","height":"80","viewBox":"0 0 84 80"};

module.exports = WY;

WY.default = WY;
